module.exports = __webpack_public_path__ + "img/IMG_3945_L_Wood.117468ad.jpg";